module.exports = __webpack_public_path__ + "img/layout6_preview.7005fc0a.jpg";